export const ADD_COMMISSION_MODAL = {
  TITLE: 'Add Commission',
  COMMISSION_TYPE_LABEL: 'Commission Type',
  SUBTYPE_LABEL: 'Default/Custom',
  CANCEL: 'Cancel',
  CONFIRM: 'Confirm',
};
